import axios from "axios";

export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const EMPTY_CART = "EMPTY_CART";
export const INITIALIZE_CART = "INITIALIZE_CART";

export const addProductToCart = (product) => ({ type: ADD_PRODUCT, payload: product });

export const removeProductFromCart = (product) => ({ type: REMOVE_PRODUCT, payload: product });

export const emptyCart = () => ({ type: EMPTY_CART });

export const initializeCart = (orderData) => ({ type: INITIALIZE_CART, payload: orderData });

